import Webcam from 'react-webcam';
import '../pages/Psychotest.css';

export default function ProctoringCamera({
  webcamRef, cameraError, faceStatus, onUserMedia, onUserMediaError, videoConstraints, size = 'large',
}) {

  const dims = size === 'large' ? { width: 220, height: 150 } : { width: 180, height: 130 };

  return (
    <div className="proctoring-camera">
      {!cameraError ? (
        <Webcam
          ref={webcamRef}
          audio={false}
          {...dims}
          playsInline
          mirrored
          videoConstraints={videoConstraints}
          onUserMedia={onUserMedia}
          screenshotFormat="image/jpeg"
          onUserMediaError={onUserMediaError}
          className="webcam-preview"
        />
      ) : (
        <div className="cam-error">❌ Kamera tidak tersedia</div>
      )}
      <div className={`face-status ${faceStatus === 'ok' ? 'ok' : 'face_missing'}`}>
        {faceStatus === 'ok'
          ? '✅ Wajah Terdeteksi'
          : faceStatus === 'face_multiple'
            ? '⚠️ Lebih dari 1 Wajah'
            : faceStatus === 'face_missing'?'❌ Wajah Tidak Ada'
          :''}
      </div>
    </div>
  );
}